// src/components/SocialShare.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter,
  faFacebookF,
  faLinkedinIn,
  faRedditAlien,
} from '@fortawesome/free-brands-svg-icons';


const SocialShare = ({ url, title, description }) => {
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title || document.title);
  const shareText = encodeURIComponent(description || '');

  const platforms = {
    twitter: `https://twitter.com/intent/tweet?text=${shareTitle}&url=${shareUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
    reddit: `https://reddit.com/submit?url=${shareUrl}&title=${shareTitle}`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareTitle} ${shareUrl}`
  };

  const handleShare = (platform) => {
    window.open(platforms[platform], '_blank', 'width=600,height=400');
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-slate-600 dark:text-slate-400">Share:</span>
      <div className="flex space-x-2">
        <button
          onClick={() => handleShare('twitter')}
          className="p-2 bg-blue-400 text-white rounded-lg hover:bg-blue-500 transition-colors"
          aria-label="Share on Twitter"
        >
           <FontAwesomeIcon icon={faTwitter} />
        </button>
        <button
          onClick={() => handleShare('facebook')}
          className="p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          aria-label="Share on Facebook"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </button>
        <button
          onClick={() => handleShare('linkedin')}
          className="p-2 bg-blue-800 text-white rounded-lg hover:bg-blue-900 transition-colors"
          aria-label="Share on LinkedIn"
        >
         <FontAwesomeIcon icon={faLinkedinIn} />
        </button>
        <button
          onClick={() => handleShare('reddit')}
          className="p-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          aria-label="Share on Reddit"
        >
          <FontAwesomeIcon icon={faRedditAlien} />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;